import React from "react";
import FileIcon from "./FileIcon";
import { CLASSES } from "../../constants";

/**
 * Component to render a single file item in the file explorer
 * @param {Object} props - Component props
 * @param {Object} props.file - File object with name, path, type, etc.
 * @param {number} props.level - Indentation level
 * @param {boolean} props.isSelected - Whether this file is currently selected
 * @param {boolean} props.isLoading - Whether this file is being loaded
 * @param {Function} props.onClick - Click handler
 * @returns {JSX.Element} The file item
 */
const FileItem = ({
  file,
  level = 0,
  isSelected = false,
  isLoading = false,
  onClick,
}) => {
  const paddingLeft = level * 16 + 8 + "px";

  const handleClick = () => {
    if (onClick && file.type === "file") {
      onClick(file);
    }
  };

  return (
    <div
      className={`
        ${CLASSES.fileItem}
        ${isSelected ? CLASSES.fileItemSelected : ""}
      `}
      style={{ paddingLeft }}
      onClick={handleClick}
    >
      {/* Empty space for alignment with directories */}
      <span className="mr-1.5 inline-block w-4"></span>

      {/* File icon */}
      <span className="mr-2">
        <FileIcon fileName={file.name} />
      </span>

      {/* File name */}
      <span className="text-xs text-neutral-800 dark:text-neutral-200 truncate">
        {file.name}
      </span>

      {/* Loading spinner */}
      {isLoading && (
        <svg
          className="animate-spin ml-auto h-4 w-4 text-neutral-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
    </div>
  );
};

export default FileItem;
